import React from 'react';
import Question from "../components/Question";

export default function DefaultPage() {
    return (
        <Question
            noBack={true}
            main={true}
            returning={false}
            title="Submitting your information so we can match you with your care team. You'll be redirected shortly."
        />
    );
}
